import { ClassNameProps, StyleProps } from "@hex-insights/core";
import { Icon, IconContainer } from "../../../../Components/Icon";
import { StudentNote, StudentNoteNoteType } from "../../../../Utilities";

export type StudentNoteIconProps = {
	studentNote: Pick<StudentNote, "noteType">;
} & StudentNoteTypeIconProps;

export function StudentNoteIcon({ studentNote, ...props }: StudentNoteIconProps) {
	switch (studentNote.noteType) {
		case StudentNoteNoteType.Academic:
			return <StudentAcademicNoteIcon {...props} />;
		case StudentNoteNoteType.Attendance:
			return <StudentAttendanceNoteIcon {...props} />;
		case StudentNoteNoteType.Behavior:
			return <StudentBehaviorNoteIcon {...props} />;
		case StudentNoteNoteType.General:
			return <StudentGeneralNoteIcon {...props} />;
		case StudentNoteNoteType.Health:
			return <StudentHealthNoteIcon {...props} />;
		case StudentNoteNoteType.Incident:
			return <StudentIncidentNoteIcon {...props} />;
		case StudentNoteNoteType.Injury:
			return <StudentInjuryNoteIcon {...props} />;
		case StudentNoteNoteType.Medication:
			return <StudentMedicationNoteIcon {...props} />;
		case StudentNoteNoteType.SocialEmotional:
			return <StudentSocialEmotionalNoteIcon {...props} />;
	}
}

export const studentNoteTypeColors = {
	academic: "var(--primary-color)",
	attendance: "var(--primary-color)",
	behavior: "var(--theme-colors__orange)",
	general: "var(--theme-colors__yellow)",
	health: "var(--theme-colors__pink)",
	incident: "var(--theme-colors__green)",
	injury: "var(--theme-colors__pink)",
	medication: "var(--theme-colors__purple)",
	socialEmotional: "var(--theme-colors__teal)",
};

export const studentNoteTypeBackgroundColors = {
	academic: "var(--primary-color--background)",
	attendance: "var(--primary-color--background)",
	behavior: "var(--theme-colors__orange--background)",
	general: "var(--theme-colors__yellow--background)",
	health: "var(--theme-colors__pink--background)",
	incident: "var(--theme-colors__green--background)",
	injury: "var(--theme-colors__pink--background)",
	medication: "var(--theme-colors__purple--background)",
	socialEmotional: "var(--theme-colors__teal--background)",
};

type StudentNoteTypeIconProps = {
	size?: number;
	color?: string;
	backgroundColor?: string;
} & Partial<ClassNameProps & StyleProps>;

export function StudentAcademicNoteIcon({
	size,
	color = studentNoteTypeColors.academic,
	backgroundColor = studentNoteTypeBackgroundColors.academic,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Exam size={size} color={color} />
		</IconContainer>
	);
}

export function StudentAttendanceNoteIcon({
	size,
	color = studentNoteTypeColors.attendance,
	backgroundColor = studentNoteTypeBackgroundColors.attendance,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.IdentificationCard size={size} color={color} />
		</IconContainer>
	);
}

export function StudentBehaviorNoteIcon({
	size,
	color = studentNoteTypeColors.behavior,
	backgroundColor = studentNoteTypeBackgroundColors.behavior,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.PersonSimpleThrow size={size} color={color} />
		</IconContainer>
	);
}

export function StudentGeneralNoteIcon({
	size,
	color = studentNoteTypeColors.general,
	backgroundColor = studentNoteTypeBackgroundColors.general,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Note size={size} color={color} />
		</IconContainer>
	);
}

export function StudentHealthNoteIcon({
	size,
	color = studentNoteTypeColors.health,
	backgroundColor = studentNoteTypeBackgroundColors.health,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.FirstAid size={size} color={color} />
		</IconContainer>
	);
}

export function StudentIncidentNoteIcon({
	size,
	color = studentNoteTypeColors.incident,
	backgroundColor = studentNoteTypeBackgroundColors.incident,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Tooth size={size} color={color} />
		</IconContainer>
	);
}

export function StudentInjuryNoteIcon({
	size,
	color = studentNoteTypeColors.injury,
	backgroundColor = studentNoteTypeBackgroundColors.injury,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Bandaids size={size} color={color} />
		</IconContainer>
	);
}

export function StudentMedicationNoteIcon({
	size,
	color = studentNoteTypeColors.medication,
	backgroundColor = studentNoteTypeBackgroundColors.medication,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Pill size={size} color={color} />
		</IconContainer>
	);
}

export function StudentSocialEmotionalNoteIcon({
	size,
	color = studentNoteTypeColors.socialEmotional,
	backgroundColor = studentNoteTypeBackgroundColors.socialEmotional,
	className,
	style,
}: StudentNoteTypeIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.FlowerLotus size={size} color={color} />
		</IconContainer>
	);
}
